"use strict";

const tenantResolution = require('@vp/tenant-resolution');
const getRootCookieDomain = () => {
  return tenantResolution.getRootCookieDomain();
};
module.exports = {
  getRootCookieDomain: getRootCookieDomain
};